<template>
  <div id="left_bar">
    <div class="left_bar_container" :style="smallMode ? 'width: auto' : ''">
      <div
        @click="changeSelected"
        v-if="allowContent.includes('terminals')"
        id="terminals"
        title="Терминалы"
        class="left_bar_container__item page_container"
        :class="[
          selectedTab === 'terminals' ? 'selected' : '',
          smallMode ? 'page_container_small' : '',
        ]"
      >
        <div class="page_container__item icon">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25 3.75H5C3.61929 3.75 2.5 4.86929 2.5 6.25V18.75C2.5 20.1307 3.61929 21.25 5 21.25H25C26.3807 21.25 27.5 20.1307 27.5 18.75V6.25C27.5 4.86929 26.3807 3.75 25 3.75Z"
              :stroke="getSvgColor('terminals')"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10 26.25H20M15 21.25V26.25"
              :stroke="getSvgColor('terminals')"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div v-if="!smallMode" class="page_container__item text">Терминалы</div>
      </div>
      <div
        v-if="allowContent.includes('groups')"
        @click="changeSelected"
        id="groups"
        class="left_bar_container__item page_container"
        title="Группы"
        :class="[
          selectedTab === 'groups' ? 'selected' : '',
          smallMode ? 'page_container_small' : '',
        ]"
      >
        <div class="page_container__item icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="#000000"
            width="30px"
            height="30px"
            viewBox="0 0 256 256"
          >
            <path
              d="M224,64H154.667l-27.7334-20.7998A16.10323,16.10323,0,0,0,117.333,40H72A16.01833,16.01833,0,0,0,56,56V72H40A16.01833,16.01833,0,0,0,24,88V200a16.01833,16.01833,0,0,0,16,16H192.88867A15.12831,15.12831,0,0,0,208,200.88867V184h16.88867A15.12831,15.12831,0,0,0,240,168.88867V80A16.01833,16.01833,0,0,0,224,64Zm0,104H208V112a16.01833,16.01833,0,0,0-16-16H122.667L94.93359,75.2002A16.10323,16.10323,0,0,0,85.333,72H72V56h45.333l27.7334,20.7998A16.10323,16.10323,0,0,0,154.667,80H224Z"
              :fill="getSvgColor('groups')"
            />
          </svg>
        </div>
        <div v-if="!smallMode" class="page_container__item text">Группы</div>
      </div>
      <div
        v-if="allowContent.includes('distributives')"
        @click="changeSelected"
        id="distributives"
        title="Дистрибутивы"
        class="left_bar_container__item page_container"
        :class="[
          selectedTab === 'distributives' ? 'selected' : '',
          smallMode ? 'page_container_small' : '',
        ]"
      >
        <div class="page_container__item icon">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            :fill="getSvgColor('distributives')"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.9094 17.8125L16.4812 20.2406L17.8125 21.5625L21.5625 17.8125L17.8125 14.0625L16.4812 15.3844L18.9094 17.8125ZM11.0906 17.8125L13.5188 15.3844L12.1875 14.0625L8.4375 17.8125L12.1875 21.5625L13.5188 20.2406L11.0906 17.8125Z"
            />
            <path
              d="M8.4375 8.4375C8.95527 8.4375 9.375 8.01777 9.375 7.5C9.375 6.98223 8.95527 6.5625 8.4375 6.5625C7.91973 6.5625 7.5 6.98223 7.5 7.5C7.5 8.01777 7.91973 8.4375 8.4375 8.4375Z"
            />
            <path
              d="M5.625 8.4375C6.14277 8.4375 6.5625 8.01777 6.5625 7.5C6.5625 6.98223 6.14277 6.5625 5.625 6.5625C5.10723 6.5625 4.6875 6.98223 4.6875 7.5C4.6875 8.01777 5.10723 8.4375 5.625 8.4375Z"
            />
            <path
              d="M26.25 3.75H3.75C2.71594 3.75 1.875 4.59094 1.875 5.625V24.375C1.875 25.4091 2.71594 26.25 3.75 26.25H26.25C27.2841 26.25 28.125 25.4091 28.125 24.375V5.625C28.125 4.59094 27.2841 3.75 26.25 3.75ZM26.25 5.625V9.375H3.75V5.625H26.25ZM3.75 24.375V11.25H26.25V24.375H3.75Z"
            />
          </svg>
        </div>
        <div v-if="!smallMode" class="page_container__item text">
          Дистрибутивы
        </div>
      </div>
      <div
        v-if="allowContent.includes('images')"
        @click="changeSelected"
        id="images"
        title="Образы"
        class="left_bar_container__item page_container"
        :class="[
          selectedTab === 'images' ? 'selected' : '',
          smallMode ? 'page_container_small' : '',
        ]"
      >
        <div class="page_container__item icon">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 11V10H0V11H1ZM5 7V6H4V7H5ZM13 3V2H12V3H13ZM17 3H18V2H17V3ZM25 15H24V16H25V15ZM2 15V11H0V15H2ZM6 15V7H4V15H6ZM5 8H17V6H5V8ZM16 7V15H18V7H16ZM10 15V7H8V15H10ZM14 15V3H12V15H14ZM13 4H17V2H13V4ZM16 3V7H18V3H16ZM27.472 20H30V18H27.472V20ZM20 10V11H22V10H20ZM24 13V15H26V13H24ZM25 16H27V14H25V16ZM28 17V19H30V17H28ZM27 16C27.2652 16 27.5196 16.1054 27.7071 16.2929C27.8946 16.4804 28 16.7348 28 17H30C30 16.2044 29.6839 15.4413 29.1213 14.8787C28.5587 14.3161 27.7956 14 27 14V16ZM23 12C23.2652 12 23.5196 12.1054 23.7071 12.2929C23.8946 12.4804 24 12.7348 24 13H26C26 12.2044 25.6839 11.4413 25.1213 10.8787C24.5587 10.3161 23.7956 10 23 10V12ZM6 20H8V18H6V20ZM17 14H1V16H17V14ZM0 15V17H2V15H0ZM11 28H12.056V26H11V28ZM12.056 28C14.4813 28 16.8727 27.4298 19.0371 26.3354C21.2014 25.2411 23.0782 23.6532 24.516 21.7L22.906 20.514C21.654 22.2148 20.0196 23.5974 18.1349 24.5504C16.2502 25.5033 14.1679 25.9999 12.056 26V28ZM0 17C0 19.9174 1.15893 22.7153 3.22183 24.7782C5.28473 26.8411 8.08262 28 11 28V26C8.61305 26 6.32387 25.0518 4.63604 23.364C2.94821 21.6761 2 19.3869 2 17H0ZM1 12H23V10H1V12ZM20 11C20 11.7956 19.6839 12.5587 19.1213 13.1213C18.5587 13.6839 17.7956 14 17 14V16C18.3261 16 19.5979 15.4732 20.5355 14.5355C21.4732 13.5979 22 12.3261 22 11H20ZM27.472 18C25.552 18 23.934 19.116 22.906 20.514L24.516 21.7C25.282 20.656 26.362 20 27.472 20V18Z"
              :fill="getSvgColor('images')"
            />
          </svg>
        </div>
        <div v-if="!smallMode" class="page_container__item text">Образы</div>
      </div>
      <div
        v-if="allowContent.includes('templates')"
        @click="changeSelected"
        id="templates"
        title="Шаблоны"
        class="left_bar_container__item page_container"
        :class="[
          selectedTab === 'templates' ? 'selected' : '',
          smallMode ? 'page_container_small' : '',
        ]"
      >
        <div class="page_container__item icon">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            :fill="getSvgColor('templates')"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25.3125 10.3125C25.3143 10.1878 25.2903 10.064 25.2419 9.94905C25.1935 9.83408 25.1218 9.7304 25.0313 9.64455L18.4805 3.08205C18.3019 2.90793 18.0619 2.81111 17.8125 2.81252H6.5625C6.06522 2.81252 5.58831 3.01006 5.23667 3.36169C4.88504 3.71332 4.6875 4.19023 4.6875 4.68752V25.3125C4.6875 25.8098 4.88504 26.2867 5.23667 26.6383C5.58831 26.99 6.06522 27.1875 6.5625 27.1875H23.4375C23.9348 27.1875 24.4117 26.99 24.7633 26.6383C25.115 26.2867 25.3125 25.8098 25.3125 25.3125V10.3125ZM18.75 6.01173L22.1133 9.37502H18.75V6.01173ZM23.4375 25.3125H6.5625V4.68752H16.875V10.3125C16.875 10.5612 16.9738 10.7996 17.1496 10.9754C17.3254 11.1512 17.5639 11.25 17.8125 11.25H23.4375V25.3125ZM20.8242 17.1445C21.0003 17.3223 21.099 17.5623 21.099 17.8125C21.099 18.0627 21.0003 18.3027 20.8242 18.4805L18.0117 21.293C17.8305 21.463 17.5922 21.5591 17.3438 21.5625C17.0948 21.5615 16.8557 21.465 16.6758 21.293C16.4997 21.1152 16.401 20.8752 16.401 20.625C16.401 20.3748 16.4997 20.1348 16.6758 19.957L18.832 17.8125L16.6758 15.668C16.5263 15.4858 16.4499 15.2546 16.4614 15.0192C16.473 14.7839 16.5717 14.5612 16.7383 14.3946C16.9049 14.228 17.1276 14.1293 17.363 14.1177C17.5983 14.1062 17.8296 14.1826 18.0117 14.332L20.8242 17.1445ZM13.3242 15.668L11.168 17.8125L13.3242 19.957C13.5003 20.1348 13.599 20.3748 13.599 20.625C13.599 20.8752 13.5003 21.1152 13.3242 21.293C13.143 21.463 12.9047 21.5591 12.6563 21.5625C12.4073 21.5615 12.1682 21.465 11.9883 21.293L9.17578 18.4805C8.99974 18.3027 8.90098 18.0627 8.90098 17.8125C8.90098 17.5623 8.99974 17.3223 9.17578 17.1445L11.9883 14.332C12.1704 14.1826 12.4017 14.1062 12.637 14.1177C12.8724 14.1293 13.0951 14.228 13.2617 14.3946C13.4283 14.5612 13.527 14.7839 13.5386 15.0192C13.5501 15.2546 13.4737 15.4858 13.3242 15.668Z"
            />
          </svg>
        </div>
        <div v-if="!smallMode" class="page_container__item text">Шаблоны</div>
      </div>
      <div
        v-if="allowContent.includes('transport')"
        @click="changeSelected"
        id="transport"
        class="left_bar_container__item page_container"
        title="Транспорт"
        :class="[
          selectedTab === 'transport' ? 'selected' : '',
          smallMode ? 'page_container_small' : '',
        ]"
      >
        <div class="page_container__item icon">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            :fill="getSvgColor('transport')"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.1497 26.666H7.14974C6.92873 26.666 6.71676 26.7538 6.56048 26.9101C6.4042 27.0664 6.31641 27.2783 6.31641 27.4993C6.31641 27.7204 6.4042 27.9323 6.56048 28.0886C6.71676 28.2449 6.92873 28.3327 7.14974 28.3327H22.1497C22.3708 28.3327 22.5827 28.2449 22.739 28.0886C22.8953 27.9323 22.9831 27.7204 22.9831 27.4993C22.9831 27.2783 22.8953 27.0664 22.739 26.9101C22.5827 26.7538 22.3708 26.666 22.1497 26.666Z"
            />
            <path
              d="M14.7917 1.66602C11.6975 1.66602 8.73001 2.89518 6.54209 5.0831C4.35416 7.27103 3.125 10.2385 3.125 13.3327C3.125 13.7077 3.125 14.0744 3.18333 14.441C3.39808 16.6912 4.26189 18.8306 5.66976 20.5991C7.07764 22.3675 8.96894 23.6889 11.1138 24.4026C13.2586 25.1163 15.5645 25.1915 17.7513 24.6192C19.9381 24.0468 21.9115 22.8515 23.4317 21.1786C24.9518 19.5056 25.9532 17.4271 26.3142 15.1957C26.6752 12.9643 26.3801 10.676 25.4649 8.60913C24.5497 6.54225 23.0538 4.78575 21.159 3.55315C19.2642 2.32055 17.0521 1.66494 14.7917 1.66602ZM14.7917 3.33268C17.4266 3.33497 19.9542 4.37714 21.825 6.23268V7.06602C18.5313 5.93253 14.9509 5.94722 11.6667 7.10768C11.4043 6.85201 11.0749 6.67578 10.7167 6.59935H10.5083C10.4083 6.24935 10.3167 5.89935 10.2417 5.54102C10.1667 5.18268 10.125 4.86602 10.0833 4.52435C11.53 3.74366 13.1478 3.33419 14.7917 3.33268ZM12.2917 8.22435C15.3181 7.2109 18.598 7.24908 21.6 8.33268C21.194 10.4499 20.3073 12.4456 19.0083 14.166C18.645 14.0122 18.2428 13.9752 17.8575 14.0603C17.4722 14.1455 17.123 14.3484 16.8583 14.641C16.5667 14.4744 16.275 14.3077 16.025 14.116C14.3428 12.9936 12.9379 11.5032 11.9167 9.75768C12.0817 9.55303 12.2019 9.31595 12.2694 9.06183C12.3368 8.80772 12.3501 8.54226 12.3083 8.28268L12.2917 8.22435ZM8.95833 5.22435C8.95833 5.39935 9.00833 5.58268 9.04167 5.75768C9.11667 6.12435 9.21667 6.48268 9.31667 6.84102C8.99756 7.02998 8.74072 7.30821 8.57783 7.64138C8.41495 7.97456 8.35313 8.34813 8.4 8.71602C7.08458 9.57501 5.90964 10.6319 4.91667 11.8494C5.11591 10.5308 5.57686 9.26545 6.27239 8.12771C6.96792 6.98996 7.88398 6.00281 8.96667 5.22435H8.95833ZM8.95833 18.316C8.63302 18.4252 8.34229 18.6183 8.1155 18.8759C7.8887 19.1334 7.73388 19.4462 7.66667 19.7827H7.13333C5.78756 18.1776 4.98267 16.1887 4.83333 14.0994L4.925 13.941C5.96851 12.323 7.33272 10.9361 8.93333 9.86602C9.17331 10.1166 9.47658 10.2977 9.81104 10.3902C10.1455 10.4826 10.4987 10.4829 10.8333 10.391C11.948 12.2746 13.4716 13.8837 15.2917 15.0994C15.6333 15.3244 15.9833 15.5327 16.3333 15.7327C16.3053 16.0514 16.3569 16.3721 16.4833 16.666C14.9583 17.877 13.1992 18.7594 11.3167 19.2577C11.0984 18.8498 10.7421 18.5328 10.3116 18.3634C9.88115 18.1939 9.40444 18.183 8.96667 18.3327L8.95833 18.316ZM14.7917 23.316C13.0969 23.3165 11.4301 22.8833 9.95 22.0577L10.1833 22.0077C10.5149 21.8989 10.8113 21.7031 11.0414 21.4407C11.2715 21.1783 11.427 20.859 11.4917 20.516C13.6225 19.9726 15.6118 18.978 17.325 17.5994C17.732 17.8372 18.2125 17.916 18.6741 17.8206C19.1357 17.7252 19.5457 17.4623 19.825 17.0827C21.0007 17.3883 22.2102 17.5451 23.425 17.5494H23.8667C23.0627 19.2782 21.7813 20.7411 20.1734 21.7658C18.5656 22.7905 16.6983 23.3341 14.7917 23.3327V23.316ZM20.2167 15.8994C20.2159 15.5501 20.1209 15.2075 19.9417 14.9077C21.3285 13.0961 22.2936 10.9979 22.7667 8.76602C23.1833 8.96046 23.5944 9.17713 24 9.41602C24.9165 11.5818 25.0405 14.0013 24.35 16.2494C22.9665 16.3563 21.5747 16.2467 20.225 15.9244L20.2167 15.8994Z"
            />
          </svg>
        </div>
        <div v-if="!smallMode" class="page_container__item text">Транспорт</div>
      </div>
      <div
        v-if="ifIntegration"
        @click="changeSelected"
        title="Интеграция"
        id="integration"
        class="left_bar_container__item page_container"
        :class="[
          selectedTab === 'integration' ? 'selected' : '',
          smallMode ? 'page_container_small' : '',
        ]"
      >
        <div class="page_container__item icon">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M26.4022 9.68993C26.4029 10.4915 26.2448 11.2853 25.9371 12.0255C25.6293 12.7657 25.178 13.4376 24.6093 14.0024L21.2928 17.3188C20.1502 18.4602 18.6012 19.1014 16.9862 19.1014C15.3712 19.1014 13.8222 18.4602 12.6796 17.3188C12.5855 17.2336 12.5096 17.1301 12.4567 17.0146C12.4038 16.8991 12.375 16.7741 12.3718 16.6472C12.3687 16.5202 12.3914 16.3939 12.4386 16.276C12.4857 16.1581 12.5563 16.051 12.6461 15.9612C12.7359 15.8714 12.8431 15.8008 12.961 15.7536C13.0789 15.7065 13.2052 15.6838 13.3321 15.6869C13.4591 15.69 13.5841 15.7189 13.6995 15.7718C13.815 15.8247 13.9185 15.9005 14.0038 15.9946C14.7964 16.7825 15.8686 17.2248 16.9862 17.2248C18.1038 17.2248 19.176 16.7825 19.9686 15.9946L23.285 12.6782C23.6906 12.2897 24.0145 11.8241 24.2377 11.3088C24.4609 10.7934 24.579 10.2387 24.585 9.67707C24.5911 9.11549 24.4849 8.55835 24.2727 8.03833C24.0606 7.51832 23.7468 7.0459 23.3496 6.64877C22.9525 6.25164 22.4801 5.93781 21.9601 5.72567C21.4401 5.51352 20.8829 5.40735 20.3213 5.41337C19.7597 5.41938 19.205 5.53747 18.6897 5.76071C18.1743 5.98394 17.7087 6.30783 17.3202 6.71337L14.9999 9.03368C14.8215 9.19527 14.5879 9.28209 14.3473 9.27617C14.1067 9.27024 13.8776 9.17203 13.7075 9.00186C13.5373 8.8317 13.4391 8.60261 13.4332 8.36203C13.4273 8.12145 13.5141 7.8878 13.6757 7.70947L15.996 5.38915C16.8497 4.54187 17.9346 3.96562 19.1147 3.73273C20.2947 3.49984 21.5172 3.62069 22.6288 4.0801C23.7404 4.53951 24.6916 5.31702 25.3629 6.31505C26.0342 7.31308 26.3958 8.48716 26.4022 9.68993ZM14.9999 20.9634L12.6796 23.2837C11.8829 24.0469 10.819 24.4677 9.71586 24.4559C8.6127 24.444 7.55805 24.0006 6.77796 23.2205C5.99786 22.4404 5.55437 21.3857 5.54255 20.2825C5.53073 19.1794 5.95152 18.1155 6.71472 17.3188L10.0311 14.0024C10.8238 13.2145 11.8959 12.7723 13.0135 12.7723C14.1312 12.7723 15.2033 13.2145 15.996 14.0024C16.1743 14.164 16.408 14.2508 16.6485 14.2449C16.8891 14.239 17.1182 14.1408 17.2884 13.9706C17.4585 13.8004 17.5568 13.5714 17.5627 13.3308C17.5686 13.0902 17.4818 12.8566 17.3202 12.6782C16.1776 11.5368 14.6286 10.8957 13.0135 10.8957C11.3985 10.8957 9.84952 11.5368 8.70691 12.6782L5.3905 15.9946C4.79429 16.5532 4.31647 17.2259 3.98547 17.9728C3.65446 18.7197 3.47702 19.5255 3.4637 20.3424C3.45038 21.1593 3.60145 21.9705 3.90792 22.7278C4.2144 23.4851 4.67003 24.173 5.24771 24.7507C5.82539 25.3284 6.51334 25.784 7.27064 26.0905C8.02795 26.397 8.83915 26.548 9.656 26.5347C10.4729 26.5214 11.2787 26.3439 12.0256 26.0129C12.7725 25.6819 13.4452 25.2041 14.0038 24.6079L16.3241 22.2876C16.4857 22.1093 16.5725 21.8756 16.5666 21.635C16.5607 21.3944 16.4624 21.1654 16.2923 20.9952C16.1221 20.825 15.893 20.7268 15.6524 20.7209C15.4119 20.715 15.1782 20.8018 14.9999 20.9634Z"
              :fill="getSvgColor('integration')"
            />
          </svg>
        </div>
        <div v-if="!smallMode" class="page_container__item text">
          Интеграция
        </div>
      </div>
      <div
        v-if="allowContent.includes('settings')"
        @click="changeSelected"
        id="settings"
        class="left_bar_container__item page_container"
        title="Настройки"
        :class="[
          selectedTab === 'settings' ? 'selected' : '',
          smallMode ? 'page_container_small' : '',
        ]"
      >
        <div class="page_container__item icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="30"
            height="30"
            viewBox="0 0 24 24"
          >
            <path
              d="M 11.130859 1 C 10.185672 1 9.3584008 1.6770236 9.1699219 2.6015625 L 8.96875 3.5957031 C 7.9576597 3.9605887 7.0388923 4.4895343 6.2324219 5.1699219 L 5.2753906 4.8496094 C 4.3783829 4.5486135 3.3832049 4.9272373 2.9101562 5.7441406 A 1.0001 1.0001 0 0 0 2.9082031 5.7460938 L 2.0390625 7.2539062 C 1.5673844 8.0723528 1.7375841 9.1257327 2.4453125 9.7519531 L 3.203125 10.421875 C 3.1075862 10.937431 3 11.449451 3 12 C 3 12.550549 3.1075862 13.062569 3.203125 13.578125 L 2.4453125 14.248047 C 1.7378643 14.874019 1.5665404 15.926105 2.0371094 16.744141 A 1.0001 1.0001 0 0 0 2.0371094 16.746094 L 2.9082031 18.253906 C 3.3810509 19.07245 4.3797986 19.448292 5.2753906 19.148438 L 6.234375 18.828125 C 7.040366 19.508238 7.9567682 20.039638 8.9667969 20.404297 L 9.1699219 21.396484 C 9.358338 22.322698 10.185672 23 11.130859 23 L 12.869141 23 C 13.814328 23 14.641599 22.322976 14.830078 21.398438 L 15.03125 20.404297 C 16.041078 20.039682 16.959756 19.510031 17.765625 18.830078 L 18.722656 19.150391 C 19.618248 19.450245 20.618949 19.072451 21.091797 18.253906 L 21.960938 16.748047 L 21.960938 16.746094 C 22.431797 15.929058 22.261346 14.875304 21.554688 14.25 L 21.552734 14.248047 L 20.796875 13.578125 C 20.89246 13.062663 21 12.550549 21 12 C 21 11.449451 20.892414 10.937431 20.796875 10.421875 L 21.554688 9.7519531 C 22.262136 9.1259807 22.43346 8.0738949 21.962891 7.2558594 A 1.0001 1.0001 0 0 0 21.962891 7.2539062 L 21.091797 5.7460938 C 20.618949 4.9275505 19.620201 4.551708 18.724609 4.8515625 L 17.765625 5.171875 C 16.959634 4.4917616 16.043232 3.9603621 15.033203 3.5957031 L 14.830078 2.6035156 L 14.830078 2.6015625 C 14.64232 1.6750184 13.813741 1 12.869141 1 L 11.130859 1 z M 11.130859 3 L 12.869141 3 A 1.0001 1.0001 0 0 0 12.871094 3 L 13.175781 4.5019531 A 1.0001 1.0001 0 0 0 13.886719 5.265625 C 15.0359 5.5870803 16.064818 6.1897218 16.892578 7 A 1.0001 1.0001 0 0 0 17.910156 7.2324219 L 19.359375 6.7480469 L 20.228516 8.2519531 L 20.228516 8.2539062 L 19.080078 9.2695312 A 1.0001 1.0001 0 0 0 18.773438 10.265625 C 18.917495 10.830299 19 11.407457 19 12 C 19 12.592543 18.91749 13.169704 18.773438 13.734375 A 1.0001 1.0001 0 0 0 19.080078 14.730469 L 20.228516 15.746094 L 19.359375 17.253906 L 17.908203 16.767578 A 1.0001 1.0001 0 0 0 16.890625 17.001953 C 16.062865 17.812231 15.033946 18.41292 13.884766 18.734375 A 1.0001 1.0001 0 0 0 13.175781 19.498047 L 12.869141 21 L 11.130859 21 L 11.128906 20.998047 L 10.824219 19.498047 A 1.0001 1.0001 0 0 0 10.113281 18.734375 C 8.9641006 18.41292 7.9351818 17.810278 7.1074219 17 A 1.0001 1.0001 0 0 0 6.0898438 16.767578 L 4.640625 17.251953 L 3.7714844 15.748047 L 3.7714844 15.746094 L 4.9199219 14.730469 A 1.0001 1.0001 0 0 0 5.2265625 13.734375 C 5.0825046 13.169704 5 12.592543 5 12 C 5 11.407457 5.0825046 10.830296 5.2265625 10.265625 A 1.0001 1.0001 0 0 0 4.9199219 9.2695312 L 3.7714844 8.2539062 L 4.640625 6.7480469 L 4.640625 6.7460938 L 6.0898438 7.2324219 A 1.0001 1.0001 0 0 0 7.1074219 6.9980469 C 7.9366867 6.1871518 8.9632441 5.5870749 10.113281 5.265625 A 1.0001 1.0001 0 0 0 10.824219 4.5019531 L 11.130859 3 z M 12 8 C 10.75 8 9.6852256 8.5047556 9.0019531 9.2734375 C 8.3186806 10.042119 8 11.027778 8 12 C 8 12.972222 8.3186806 13.957881 9.0019531 14.726562 C 9.6852256 15.495245 10.75 16 12 16 C 13.25 16 14.314774 15.495244 14.998047 14.726562 C 15.681319 13.957882 16 12.972222 16 12 C 16 11.027778 15.681319 10.042119 14.998047 9.2734375 C 14.314774 8.5047556 13.25 8 12 8 z M 12 10 C 12.749999 10 13.185226 10.245244 13.501953 10.601562 C 13.81868 10.957882 14 11.472222 14 12 C 14 12.527778 13.81868 13.042119 13.501953 13.398438 C 13.185226 13.754755 12.749999 14 12 14 C 11.250001 14 10.814774 13.754756 10.498047 13.398438 C 10.18132 13.042118 10 12.527778 10 12 C 10 11.472222 10.18132 10.957881 10.498047 10.601562 C 10.814774 10.245245 11.250001 10 12 10 z"
              :fill="getSvgColor('settings')"
            ></path>
          </svg>
        </div>
        <div v-if="!smallMode" class="page_container__item text">Настройки</div>
      </div>
      <div
          v-if="allowContent.includes('usbInstaller')"
          @click="changeSelected"
          id="usb-installer"
          class="left_bar_container__item page_container"
          title="USB installer"
          :class="[
          selectedTab === 'usbinstaller' ? 'selected' : '',
          smallMode ? 'page_container_small' : '',
        ]"
      >
        <div class="page_container__item icon">
          <svg viewBox="0 0 512 512" width="30px" height="30px" :fill="getSvgColor('usbinstaller')"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier">  <g> <path class="st0" d="M10.459,295.598c-14.015,14.021-13.934,36.907,0.183,51.024l154.733,154.735 c6.862,6.862,15.982,10.643,25.679,10.643h0.004c9.592,0,18.59-3.714,25.338-10.462L407.64,310.292L201.703,104.359L10.459,295.598 z M100.477,296.982c-3.311,0-6.424-1.288-8.764-3.629l-1.778-1.781c-2.342-2.34-3.631-5.451-3.631-8.762 c0-3.314,1.289-6.425,3.631-8.766l97.638-97.638c2.342-2.34,5.455-3.633,8.766-3.633c3.313,0,6.425,1.292,8.768,3.633l1.774,1.774 c4.833,4.833,4.833,12.698,0,17.531l-97.638,97.638C106.9,295.694,103.788,296.982,100.477,296.982z"></path> <path class="st0" d="M508.677,153.909L358.086,3.318C355.946,1.178,353.109,0,350.102,0c-3.016,0-5.856,1.178-7.997,3.318 L240.69,104.733l23.598,23.594l85.807-85.806l119.382,119.38l-85.809,85.809l23.597,23.594l101.413-101.411 c2.133-2.133,3.312-4.962,3.322-7.966C512.006,158.909,510.827,156.061,508.677,153.909z"></path> <rect x="311.355" y="98.494" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 486.2986 446.7168)" class="st0" width="48.619" height="48.304"></rect> <polygon class="st0" points="423.562,176.051 389.407,141.9 355.249,176.051 389.407,210.207 "></polygon> </g> </g></svg>
        </div>
        <div v-if="!smallMode" class="page_container__item text">USB Installer</div>
      </div>
    </div>
  </div>
</template>

<script>
import { integrationMode } from "@/config";
export default {
  name: "LeftBar",
  props: {
    defaultTab: {
      type: String,
      default() {
        return "terminals";
      },
    },
    smallMode: {
      type: Boolean,
      default() {
        return false;
      },
    },
    allowContent: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      svgBaseColor: "#010101",
      svgSelectedColor: "#FFFFFF",
      selectedTabID: null,
    };
  },
  methods: {
    changeSelected(event) {
      this.selectedTabId = event.currentTarget.id;
      this.$router.push(`/${this.selectedTabId}`);
    },
    getSvgColor(idTag) {
      return idTag == this.selectedTab
        ? this.svgSelectedColor
        : this.svgBaseColor;
    },
  },
  computed: {
    selectedTab() {
      return this.selectedTabID !== null ? this.selectedTabID : this.defaultTab;
    },
    ifIntegration() {
      return (
        integrationMode !== null &&
        integrationMode !== undefined &&
        integrationMode !== ""
      );
    },
  },
};
</script>

<style lang="less">
#left_bar {
  height: 100%;
}

.left_bar_container {
  display: flex;
  flex-direction: column;
  // width: 206px;
  height: 100%;
  background-color: #d6e6ff;
  padding-top: 20px;

  .left_bar_container__item {
    height: 50px;

    &.selected {
      background-color: #2d4e80;

      .text {
        color: #ffffff;
      }
    }
  }
}

.page_container {
  display: flex;
  align-items: center;
  padding: 5px 25px 5px 25px;

  @media (max-width: 400px) {
  }
  @media (min-width: 401px) {
  }

  &.page_container_small {
    justify-content: center;
  }

  .page_container__item {
    cursor: pointer;
    &.text {
      margin-left: 12.5px;
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: #010101;
    }
  }
}
</style>
